/**
 * Работа с метрикой в приложении.
 */
class Metric {
  /**
   * Флаг, что метрика инициализирована.
   */
  APP_METRIC_INITIALIZED = false;

  params: StatsEventData[] = [];

  /**
   * Инициализация метрики.
   */
  initialize() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    if (this.APP_METRIC_INITIALIZED) {
      return;
    }

    const script = document.createElement('script');
    const firstPageScript = document.getElementsByTagName('script')[0];
    script.src = 'https://www.mos.ru/shared/counters/spatz.js';
    firstPageScript?.parentNode?.insertBefore(script, firstPageScript);

    const initAdditionalCounter = () => {
      if (window.Spatz) {
        window.Spatz.addYaCounter(
          14112952,
          {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: false,
            trackHash: true,
          },
          {
            initOnly: true,
          },
        );
        this.params = this.params.reverse();
        while (this.params.length) {
          this.sendStats(this.params.pop()!);
        }
      }
      script.removeEventListener('load', () => {
        initAdditionalCounter();
      });
    };

    script.addEventListener('load', () => {
      initAdditionalCounter();
    });

    this.APP_METRIC_INITIALIZED = true;
  }

  /**
   * Отправка параметров визита в обе метрики и Egis
   *
   * @see https://olymp-moscow.atlassian.net/wiki/spaces/pg/pages/3625779878/Spatz
   */

  EVENT_TYPE = 'water2018';

  EVENT_SRC = window.location.href;

  sendStats = (data: StatsEventData) => {
    if (window.Spatz) {
      const schema = {
        type: this.EVENT_TYPE,
        src: this.EVENT_SRC,
        data,
      };
      window.Spatz.send(schema, { yandex: true, mosStats: true });
    } else {
      this.params.push(data);
    }
  };
}

const metrika = new Metric();

export default metrika;
